var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{},[_c('div',[_c('Subscribe2')],1),_c('div',{staticClass:"bge3ceff-opa rounded-t-5555 mt-12"},[_c('DownloadApp'),_c('Footer')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }